define('modules/filter/filter_model',['backbone',
  'session'
], function (Backbone, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      id: null,
      moduleApi: null
    },

    parse: function (response) {
      return response;
    },

    url: function () {
      if (this.has('moduleApi')) {
        return session.get('apiUrl') + this.get('moduleApi') + '/filter/' + this.get('id');
      } else if (this.has('id')) {
        return session.get('apiUrl') + 'filters/' + this.get('id');
      } else {
        return session.get('apiUrl') + 'filters/new';
      }
    }
  });
  return Model;
});

